module.exports = __webpack_public_path__ + "media/png/Landing_Logo_Color_Black-fdcd6c21.png";